import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = { class: "flex items-start justify-between gap-4 border-b border-ewhite-200 px-5 py-4" };
const _hoisted_3 = { class: "min-w-0" };
const _hoisted_4 = { class: "text-xs font-semibold uppercase tracking-wide text-eorange-600" };
const _hoisted_5 = { class: "text-xl font-bold text-eblack-900" };
const _hoisted_6 = ["aria-label"];
const _hoisted_7 = { class: "overflow-y-auto" };
const _hoisted_8 = { class: "grid gap-6 p-5 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)]" };
const _hoisted_9 = { class: "flex flex-col gap-3" };
const _hoisted_10 = { class: "aspect-[4/3] overflow-hidden rounded-lg bg-ewhite-100" };
const _hoisted_11 = ["src", "alt"];
const _hoisted_12 = {
    key: 1,
    class: "flex h-full w-full items-center justify-center text-eblack-400"
};
const _hoisted_13 = {
    key: 0,
    class: "grid grid-cols-4 gap-2"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["src", "alt"];
const _hoisted_16 = { class: "flex flex-col gap-5" };
const _hoisted_17 = { class: "flex flex-wrap gap-2" };
const _hoisted_18 = {
    key: 0,
    class: "rounded-full bg-ewhite-100 px-3 py-1 text-xs font-semibold text-eblack-700"
};
const _hoisted_19 = {
    key: 1,
    class: "rounded-full bg-ewhite-100 px-3 py-1 text-xs font-semibold text-eblack-700"
};
const _hoisted_20 = { class: "rounded-full bg-eorange-50 px-3 py-1 text-xs font-semibold text-eorange-700" };
const _hoisted_21 = { class: "flex items-start gap-2 text-sm text-eblack-600" };
const _hoisted_22 = {
    key: 0,
    class: "flex flex-col gap-2"
};
const _hoisted_23 = { class: "text-sm font-bold text-eblack-900" };
const _hoisted_24 = { class: "text-sm leading-relaxed text-eblack-600" };
const _hoisted_25 = {
    key: 1,
    class: "flex flex-col gap-2"
};
const _hoisted_26 = { class: "text-sm font-bold text-eblack-900" };
const _hoisted_27 = { class: "text-sm leading-relaxed text-eblack-600" };
const _hoisted_28 = { class: "grid grid-cols-1 gap-3 text-sm sm:grid-cols-2" };
const _hoisted_29 = {
    key: 0,
    class: "rounded-lg bg-ewhite-50 p-3"
};
const _hoisted_30 = { class: "font-semibold text-eblack-900" };
const _hoisted_31 = { class: "mt-1 text-eblack-600" };
const _hoisted_32 = {
    key: 1,
    class: "rounded-lg bg-ewhite-50 p-3"
};
const _hoisted_33 = { class: "font-semibold text-eblack-900" };
const _hoisted_34 = { class: "mt-1 text-eblack-600" };
const _hoisted_35 = { class: "flex justify-end gap-3 border-t border-ewhite-200 px-5 py-4" };
const _hoisted_36 = ["disabled"];
import { computed, ref, watch } from "vue";
import { IconMapPin, IconMessageCircle, IconPhoto, IconX, } from "@tabler/icons-vue";
import { getCountryName } from "@/utils/country-name";
import CatalogServiceReviews from "./CatalogServiceReviews.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CatalogServiceDetailModal',
    props: {
        service: {},
        canCreateConversation: { type: Boolean },
        isCreatingConversation: { type: Boolean }
    },
    emits: ["close", "chat"],
    setup(__props) {
        const props = __props;
        const selectedPhoto = ref(null);
        const photoUrls = computed(() => [...(props.service.photoUrls ?? []), ...(props.service.photo_urls ?? [])]
            .filter(Boolean)
            .filter((url, index, urls) => urls.indexOf(url) === index));
        const mainPhoto = computed(() => selectedPhoto.value ?? photoUrls.value[0] ?? null);
        watch(() => props.service.id, () => {
            selectedPhoto.value = null;
        });
        const locationLabel = computed(() => {
            const country = props.service.country ? getCountryName(props.service.country) : null;
            return [
                country,
                props.service.location_one,
                props.service.location_two,
                props.service.location_three,
            ]
                .filter(Boolean)
                .join(", ");
        });
        const bookingWindowLabel = computed(() => {
            const min = props.service.min_time_booking;
            const max = props.service.max_time_booking;
            if (min == null && max == null)
                return "";
            if (min != null && max != null) {
                return `Entre ${formatDayCount(min)} y ${formatDayCount(max)} antes`;
            }
            if (min != null)
                return `Mínimo ${formatDayCount(min)} antes`;
            return `Máximo ${formatDayCount(max)} antes`;
        });
        const cancellationLabel = computed(() => {
            const days = props.service.cancellation_policy_duration;
            if (days == null)
                return "";
            if (days === 0)
                return "Sin ventana definida";
            return `${formatDayCount(days)} antes del servicio`;
        });
        function durationLabel(duration) {
            if (!duration)
                return "Duración no especificada";
            if (duration < 60)
                return `${duration} min`;
            const hours = Math.floor(duration / 60);
            const minutes = duration % 60;
            return minutes ? `${hours} h ${minutes} min` : `${hours} h`;
        }
        function formatDayCount(value) {
            const days = Number(value ?? 0);
            return `${days} ${days === 1 ? "día" : "días"}`;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", {
                class: "flex max-h-[90vh] w-full flex-col overflow-hidden rounded-lg bg-white shadow-xl",
                role: "dialog",
                "aria-modal": "true",
                "aria-label": __props.service.name
            }, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("p", _hoisted_4, _toDisplayString(__props.service.provider?.name || "Proveedor"), 1),
                        _createElementVNode("h2", _hoisted_5, _toDisplayString(__props.service.name), 1)
                    ]),
                    _createElementVNode("button", {
                        type: "button",
                        class: "flex h-9 w-9 items-center justify-center rounded-md text-eblack-500 transition hover:bg-ewhite-100",
                        "aria-label": _ctx.$t('services.auto.cerrar'),
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close')))
                    }, [
                        _createVNode(_unref(IconX), { class: "h-5 w-5" })
                    ], 8, _hoisted_6)
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                                (mainPhoto.value)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: mainPhoto.value,
                                        alt: __props.service.name,
                                        class: "h-full w-full object-cover"
                                    }, null, 8, _hoisted_11))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                        _createVNode(_unref(IconPhoto), { class: "h-10 w-10" })
                                    ]))
                            ]),
                            (photoUrls.value.length > 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(photoUrls.value, (url) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                            key: url,
                                            type: "button",
                                            class: _normalizeClass(["aspect-square overflow-hidden rounded-md border",
                                                url === mainPhoto.value
                                                    ? 'border-eorange-500'
                                                    : 'border-ewhite-200'
                                            ]),
                                            onClick: ($event) => (selectedPhoto.value = url)
                                        }, [
                                            _createElementVNode("img", {
                                                src: url,
                                                alt: __props.service.name,
                                                class: "h-full w-full object-cover"
                                            }, null, 8, _hoisted_15)
                                        ], 10, _hoisted_14));
                                    }), 128))
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                                (__props.service.category?.name)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(__props.service.category.name), 1))
                                    : _createCommentVNode("", true),
                                (__props.service.service_type?.name)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(__props.service.service_type.name), 1))
                                    : _createCommentVNode("", true),
                                _createElementVNode("span", _hoisted_20, _toDisplayString(durationLabel(__props.service.duration)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                                _createVNode(_unref(IconMapPin), { class: "mt-0.5 h-4 w-4 flex-shrink-0 text-eorange-500" }),
                                _createElementVNode("span", null, _toDisplayString(locationLabel.value || "Ubicación no especificada"), 1)
                            ]),
                            (__props.service.description)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                    _createElementVNode("h3", _hoisted_23, _toDisplayString(_ctx.$t("services.auto.descripcion")), 1),
                                    _createElementVNode("p", _hoisted_24, _toDisplayString(__props.service.description), 1)
                                ]))
                                : _createCommentVNode("", true),
                            (__props.service.additional_information)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    _createElementVNode("h3", _hoisted_26, _toDisplayString(_ctx.$t("services.auto.notas_o_solicitudes_para_el_concierge")), 1),
                                    _createElementVNode("p", _hoisted_27, _toDisplayString(__props.service.additional_information), 1)
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("dl", _hoisted_28, [
                                (bookingWindowLabel.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                        _createElementVNode("dt", _hoisted_30, _toDisplayString(_ctx.$t("services.auto.reserva")), 1),
                                        _createElementVNode("dd", _hoisted_31, _toDisplayString(bookingWindowLabel.value), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                (cancellationLabel.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                        _createElementVNode("dt", _hoisted_33, _toDisplayString(_ctx.$t("services.auto.cancelacion")), 1),
                                        _createElementVNode("dd", _hoisted_34, _toDisplayString(cancellationLabel.value), 1)
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            (__props.service.id != null)
                                ? (_openBlock(), _createBlock(CatalogServiceReviews, {
                                    key: 2,
                                    "service-id": __props.service.id
                                }, null, 8, ["service-id"]))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("button", {
                        type: "button",
                        class: "rounded-lg border border-ewhite-300 px-4 py-2 text-sm font-semibold text-eblack-600 transition hover:bg-ewhite-100",
                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('close')))
                    }, _toDisplayString(_ctx.$t("services.auto.cerrar")), 1),
                    (__props.canCreateConversation)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "inline-flex items-center gap-2 rounded-lg bg-eorange-500 px-4 py-2 text-sm font-semibold text-white transition hover:bg-eorange-600 disabled:cursor-not-allowed disabled:opacity-60",
                            disabled: __props.isCreatingConversation,
                            onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('chat', __props.service)))
                        }, [
                            _createVNode(_unref(IconMessageCircle), { class: "h-4 w-4" }),
                            _createTextVNode(" " + _toDisplayString(__props.isCreatingConversation ? "Abriendo..." : "Chat"), 1)
                        ], 8, _hoisted_36))
                        : _createCommentVNode("", true)
                ])
            ], 8, _hoisted_1));
        };
    }
});
